import React from "react";
import { useTranslation } from "react-i18next";

import {
  formatDateInputBr,
  formatRainMm,
  parseDateInputLocal,
} from "../../utils/rainHeatmapUtils";

function weekdayLabel(dateStr, locale) {
  const date = parseDateInputLocal(dateStr);
  if (!date) return "";
  return date.toLocaleDateString(locale, { weekday: "short" });
}

function RainMonthPrintSheet({
  farmName,
  monthTitle,
  days,
  gauges,
  dailyByStation,
}) {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === "en-US" ? "en-US" : "pt-BR";
  const stations = gauges || [];
  const rows = (days || []).map((day) => {
    const values = stations.map((gauge) => {
      const key = gauge.stationUuid || gauge.id;
      const daily = dailyByStation && key ? dailyByStation[key] : null;
      return Number(daily && daily[day]) || 0;
    });
    const average = values.length
      ? values.reduce((total, value) => total + value, 0) / values.length
      : 0;
    return { day, values, average };
  });
  const monthAverage = rows.length
    ? rows.reduce((total, row) => total + row.average, 0) / rows.length
    : 0;

  return (
    <div className="rain-month-print-sheet">
      <div className="rain-month-print-sheet__head">
        <h2>{t("Planilha de chuva")}</h2>
        <p>
          <strong>{farmName}</strong>
          {" · "}
          {monthTitle}
          {" · "}
          {t("Média")}: {formatRainMm(monthAverage)} mm
        </p>
      </div>
      <table className="rain-month-print-sheet__table">
        <thead>
          <tr>
            <th>{t("Dia")}</th>
            <th>{t("Dia da semana")}</th>
            {stations.map((gauge) => (
              <th key={gauge.id}>{gauge.label}</th>
            ))}
            <th>{t("Média")}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.day}>
              <td>{formatDateInputBr(row.day)}</td>
              <td>{weekdayLabel(row.day, locale)}</td>
              {row.values.map((value, index) => (
                <td key={`${row.day}-${index}`}>{formatRainMm(value)}</td>
              ))}
              <td>
                <strong>{formatRainMm(row.average)}</strong>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default RainMonthPrintSheet;
